import { Variants } from 'framer-motion';

export const floatingMessagingThreadWindowVariants: Variants = {
  sideOverOpen: ({ x, openY }) => ({ x, opacity: 1, y: openY }),
  sideOverClosed: ({ x, openY }) => ({ x, opacity: 1, y: openY }),
  exit: { translateY: 40, translateX: 0, opacity: 0 },
  initial: ({ x, initialY }) => ({ opacity: 0, x, y: initialY }),
};
